import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";

export const activities = [
  {
    id: 1,
    title: "Official Vehicle Support",
    description:
      "Across FIFA’s international tournaments, Kia has served as the official mobility partner, ensuring seamless movement for players and officials. Even behind the scenes, Kia keeps the game moving—supporting the moments that shape football on the world’s biggest stage.",
    image: `/fifa/fifa-bottom-card-img-1.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 2,
    title: "Youth and Future Generation Programs",
    description:
      "Kia continues to support FIFA’s diverse football stages—from youth and women’s tournaments to futsal and the eWorld Cup—where the future of the game takes shape. Through this commitment, football becomes a platform for inclusion, reinforcing the value of a sport that is open to all.",
    image: `/fifa/fifa-bottom-card-img-2.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 3,
    title: "FIFA Fan Festival",
    description:
      "The FIFA Fan Festival is a celebratory space where fans come together beyond the stadium. At the festival, Kia offers mobility-focused experiences that bring the excitement and culture of football to life.",
    image: `/fifa/fifa-bottom-card-img-3.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 4,
    title: "Brand Booth",
    description:
      "Kia’s brand booth is a space for meaningful interaction with fans—where the future of mobility comes to life. Through its EV lineup, Kia clearly expresses its identity as an electrified brand and its vision for sustainable mobility.",
    image: `/fifa/fifa-bottom-card-img-4.webp?v=${FIFA_ASSET_VERSION}`,
  },
];